<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
const version = require("element-ui/package.json").version; // element-ui version from node_modules
import store from '@/store'
export default {
  name: "App",
  data() {
    return {
      default_color: "#409EFF",
      beforeunloadTime: 0,
      unloadTime: 0
    };
  },
  mounted() {
    // var theme = sessionStorage.getItem("theme");
    // 
    // if (theme) 
    this.theme("#009966");
    
  },
  // created(){
  //   window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
  //   window.addEventListener('unload', e => this.unload(e));
  // },
  // destroyed() {
  //   window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
  //   window.removeEventListener('unload', e => this.unload(e));
  // },
  async beforeMount() {
    //this.refresh() ;
  },
  methods: {
    refresh(){
    console.log("app","beforeMount")
        this.timer = setTimeout(async () => {
            await store.dispatch('refreshToken');
            setTimeout(this.refresh(),1200000)
        }, 1200000) //设30分钟后刷新
    },
    beforeunloadHandler(e) {
      this.beforeunloadTime = new Date().getTime()
      console.log(e)
      e=e||window.event;
      if(e){
        e.returnValue="关闭提示";
      }
      return "关闭提示"
    },
    unload() {
      console.log("aa","aa")
      this.unloadTime = new Date().getTime()
      if (this.unloadTime - this.beforeunloadTime <= 1) {
        // 执行退出登录
         store.dispatch('logout');
      }
    },

    async theme(val) {
      
      val = val ? val : this.default_color;
      const oldVal = this.default_color;
      if (typeof val !== "string") return;
      const themeCluster = this.getThemeCluster(val.replace("#", ""));
      const originalCluster = this.getThemeCluster(
        this.default_color.replace("#", "")
      );
      // 

      const getHandler = (variable, id) => {
        return () => {
          const originalCluster = this.getThemeCluster(
            this.default_color.replace("#", "")
          );
          const newStyle = this.updateStyle(
            this[variable],
            originalCluster,
            themeCluster
          );

          let styleTag = document.getElementById(id);
          if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.setAttribute("id", id);
            document.head.appendChild(styleTag);
          }
          styleTag.innerText = newStyle;
        };
      };

      if (!this.chalk) {
        const url = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`;
        await this.getCSSString(url, "chalk");
      }

      const chalkHandler = getHandler("chalk", "chalk-style");

      chalkHandler();

      const styles = [].slice
        .call(document.querySelectorAll("style"))
        .filter((style) => {
          const text = style.innerText;
          return (
            new RegExp(oldVal, "i").test(text) && !/Chalk Variables/.test(text)
          );
        });
      styles.forEach((style) => {
        const { innerText } = style;
        if (typeof innerText !== "string") return;
        style.innerText = this.updateStyle(
          innerText,
          originalCluster,
          themeCluster
        );
      });
    },
    updateStyle(style, oldCluster, newCluster) {
      let newStyle = style;
      oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, "ig"), newCluster[index]);
      });
      return newStyle;
    },
    getCSSString(url, variable) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, "");
            resolve();
          }
        };
        xhr.open("GET", url);
        xhr.send();
      });
    },
    getThemeCluster(theme) {
      const tintColor = (color, tint) => {
        let red = parseInt(color.slice(0, 2), 16);
        let green = parseInt(color.slice(2, 4), 16);
        let blue = parseInt(color.slice(4, 6), 16);

        if (tint === 0) {
          // when primary color is in its rgb space
          return [red, green, blue].join(",");
        } else {
          red += Math.round(tint * (255 - red));
          green += Math.round(tint * (255 - green));
          blue += Math.round(tint * (255 - blue));

          red = red.toString(16);
          green = green.toString(16);
          blue = blue.toString(16);

          return `#${red}${green}${blue}`;
        }
      };

      const shadeColor = (color, shade) => {
        let red = parseInt(color.slice(0, 2), 16);
        let green = parseInt(color.slice(2, 4), 16);
        let blue = parseInt(color.slice(4, 6), 16);

        red = Math.round((1 - shade) * red);
        green = Math.round((1 - shade) * green);
        blue = Math.round((1 - shade) * blue);

        red = red.toString(16);
        green = green.toString(16);
        blue = blue.toString(16);

        return `#${red}${green}${blue}`;
      };

      const clusters = [theme];
      for (let i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
      }
      clusters.push(shadeColor(theme, 0.1));
      return clusters;
    },
  },
};
</script>
